export default [
    {
        id: 1,
        type: 'sports',
        website: 'fitness',
        image: '/redlane-spa/fitness/services/pickleball.jpeg',
        title: 'Pickleball',
        description: 'If you enjoy racquet sports, you’re sure to love pickleball!  This sport incorporates elements of tennis, table tennis and badminton into a fun game enjoyed by amateurs and experts alike!',
        price: 50,
        resorts: ['BTC'],
        footer: 'please speak with a Red Lane Spa representative on resort.'
    }
];
